const TreeAPI = (function() {

	/**
	 * Classe permettant de représenter le noeud d'un arbre.
	 * 
	 * Un noeud possède un identifiant et contient une valeur.
	 * Un noeud possède une référence vers son noeud parent, s'il en a un et également une référence
	 * vers ses noeud enfants, s'il en a.
	 */
	class TreeNode {

		constructor(id, value, parent) {
			this.id = id;
			this.value = value;
			this.parent = parent;
			this.children = new Map();

			if (parent !== undefined && parent !== null)
				parent.children.set(id, this);
		}

		/**
		 * Parcours l'arbre en profondeur. Utilise l'algorithme de parcours préfixe.
		 * Cf: https://en.wikipedia.org/wiki/Tree_traversal
		 * 
		 * @param {Function} nodeConsumer un consumer qui prend en paramètre l'identifiant du noeud et le noeud
		 */
		walkPreOrder(nodeConsumer) {
			if (nodeConsumer === undefined || nodeConsumer === null)
				throw new Error('Consumer should be defined');

			nodeConsumer(this.id, this);
			this.children.forEach((child, _key, _map) => {
				child.walkPreOrder(nodeConsumer, false);
			});
		}


		/**
		 * Parcours l'arbre en profondeur. Utilise l'algorithme de parcours suffixe.
		 * Cf: https://en.wikipedia.org/wiki/Tree_traversal
		 * 
		 * @param {Function} nodeConsumer un consumer qui prend en paramètre l'identifiant du noeud et le noeud
		 */
		walkPostOrder(nodeConsumer) {
			if (nodeConsumer === undefined || nodeConsumer === null)
				throw new Error('Consumer should be defined');

			this.children.forEach((child, key, _map) => {
				child.walkPostOrder(nodeConsumer, false);
			});
			nodeConsumer(this.id, this);
		}

		/**
		 * Réduit les noeuds de l'arbre à une seule valeur en utilisant la valeur initiale et un fonction d'accumulation.
		 * 
		 * @param {*} initialValue valeur initialiale
		 * @param {Function} reducer fonction qui prend en paramètre la valeur actuelle et un noeud et qui renvoie la nouvelle valeur
		 * @returns la valeur réduite
		 */
		reduce(initialValue, reducer) {
			if (reducer === undefined || reducer === null)
				throw new Error('reducer should be defined');

			let result = reducer(initialValue, this);
			this.children.forEach((child, _key, _map) => {
				result = child.reduce(result, reducer);
			});
			return result;
		}

		/**
		 * Parcours l'arbre en remontant les noeuds jusqu'à la racine.
		 * 
		 * @param {Function} nodeConsumer consumer qui prend en paramètre l'id d'un noeud et le noeud
		 */
		walkParents(nodeConsumer) {
			if (nodeConsumer === undefined || nodeConsumer === null)
				throw new Error('Consumer should be defined');

			nodeConsumer(this.id, this);
			if (this.parent !== undefined && this.parent !== null) {
				this.parent.walkParents(nodeConsumer);
			}
		}

		/**
		 * Vérifie que tous les noeuds de l'arbre valide un prédicat.
		 * 
		 * @param {Function} nodePredicate un prédicat qui prend en paramètre un noeud
		 * @returns true si tous les noeuds valident le prédicat, false sinon
		 */
		allChildrenMatch(nodePredicate) {
			if (nodePredicate === undefined || nodePredicate === null)
				throw new Error('Predicate should be defined');

			if (!nodePredicate(this))
				return false;

			for (const child of this.children.values()) {
				if (!child.allChildrenMatch(nodePredicate))
					return false;
			}
			return true;
		}

		/**
		 * Vérifie qu'au moins un noeud de l'arbre valide un prédicat'
		 * 
		 * @param {Function} nodePredicate un prédicat qui prend en paramètre un noeud
		 * @returns true si un noeud valide le prédicat, false sinon
		 */
		anyChildMatch(nodePredicate) {
			if (nodePredicate === undefined || nodePredicate === null)
				throw new Error('Predicate should be defined');

			if (nodePredicate(this))
				return true;

			for (const child of this.children.values()) {
				if (child.anyChildMatch(nodePredicate))
					return true;
			}
			return false;
		}

		/**
		 * Ajoute un enfant au noeud actuel.
		 * 
		 * @param {TreeAPI.TreeNode} child noeud d'arbre
		 */
		addChild(child) {
			this.children.set(child.id, child);
		}
	}

	return {
		TreeNode: TreeNode
	};

})();

window.TreeAPI = TreeAPI;